module.exports = __webpack_public_path__ + "img/navigation-drawer-logo.405b0cac.svg";